/*!
 * Gallery Lightbox
 * Reads images already rendered by gallery.liquid — no API calls needed.
 */
(function () {
  "use strict";

  // ── Lightbox element (built once, reused across all galleries) ──────────────

  var lb, lbImg, lbCounter, lbPrev, lbNext;
  var images = [];
  var current = 0;

  function buildLightbox() {
    if (document.getElementById("ag-lightbox")) return;

    var style = document.createElement("style");
    style.textContent = [
      ".ag-lb{display:none;position:fixed;inset:0;z-index:99999;align-items:center;justify-content:center;}",
      ".ag-lb.open{display:flex;}",
      ".ag-lb-bg{position:absolute;inset:0;background:rgba(0,0,0,.92);cursor:zoom-out;}",
      ".ag-lb-wrap{position:relative;z-index:1;display:flex;align-items:center;gap:16px;padding:0 8px;max-width:100vw;}",
      ".ag-lb-stage{position:relative;display:flex;align-items:center;justify-content:center;max-width:calc(100vw - 160px);max-height:90vh;}",
      "@media(max-width:600px){.ag-lb-stage{max-width:calc(100vw - 80px);}}",
      ".ag-lb-img{max-width:100%;max-height:88vh;object-fit:contain;border-radius:4px;display:block;user-select:none;}",
      ".ag-lb-close{position:absolute;top:-44px;right:0;background:none;border:none;color:#fff;font-size:32px;line-height:1;cursor:pointer;padding:4px 8px;opacity:.8;}",
      ".ag-lb-close:hover{opacity:1;}",
      ".ag-lb-nav{background:rgba(255,255,255,.12);border:none;color:#fff;font-size:44px;line-height:1;padding:12px 10px;border-radius:6px;cursor:pointer;flex-shrink:0;transition:background .2s;user-select:none;}",
      ".ag-lb-nav:hover{background:rgba(255,255,255,.22);}",
      "@media(max-width:600px){.ag-lb-nav{font-size:28px;padding:8px 6px;}}",
      ".ag-lb-counter{position:absolute;bottom:-30px;left:50%;transform:translateX(-50%);color:rgba(255,255,255,.6);font-size:13px;font-family:sans-serif;white-space:nowrap;}",
    ].join("");
    document.head.appendChild(style);

    lb = document.createElement("div");
    lb.id = "ag-lightbox";
    lb.className = "ag-lb";
    lb.setAttribute("role", "dialog");
    lb.setAttribute("aria-modal", "true");
    lb.setAttribute("aria-label", "Image viewer");

    var bg = document.createElement("div");
    bg.className = "ag-lb-bg";
    bg.addEventListener("click", close);

    lbPrev = document.createElement("button");
    lbPrev.className = "ag-lb-nav";
    lbPrev.innerHTML = "&#8249;";
    lbPrev.setAttribute("aria-label", "Previous");
    lbPrev.addEventListener("click", function () { go(-1); });

    var stage = document.createElement("div");
    stage.className = "ag-lb-stage";

    var closeBtn = document.createElement("button");
    closeBtn.className = "ag-lb-close";
    closeBtn.innerHTML = "&times;";
    closeBtn.setAttribute("aria-label", "Close");
    closeBtn.addEventListener("click", close);

    lbImg = document.createElement("img");
    lbImg.className = "ag-lb-img";
    lbImg.alt = "";

    lbCounter = document.createElement("div");
    lbCounter.className = "ag-lb-counter";

    stage.appendChild(closeBtn);
    stage.appendChild(lbImg);
    stage.appendChild(lbCounter);

    lbNext = document.createElement("button");
    lbNext.className = "ag-lb-nav";
    lbNext.innerHTML = "&#8250;";
    lbNext.setAttribute("aria-label", "Next");
    lbNext.addEventListener("click", function () { go(1); });

    var wrap = document.createElement("div");
    wrap.className = "ag-lb-wrap";
    wrap.appendChild(lbPrev);
    wrap.appendChild(stage);
    wrap.appendChild(lbNext);

    lb.appendChild(bg);
    lb.appendChild(wrap);
    document.body.appendChild(lb);

    // Keyboard
    document.addEventListener("keydown", function (e) {
      if (!lb.classList.contains("open")) return;
      if (e.key === "Escape")      close();
      if (e.key === "ArrowLeft")   go(-1);
      if (e.key === "ArrowRight")  go(1);
    });

    // Swipe
    var tx = 0;
    lb.addEventListener("touchstart", function (e) { tx = e.touches[0].clientX; }, { passive: true });
    lb.addEventListener("touchend",   function (e) {
      var diff = tx - e.changedTouches[0].clientX;
      if (Math.abs(diff) > 50) go(diff > 0 ? 1 : -1);
    }, { passive: true });
  }

  function open(index, galleryImages) {
    buildLightbox();
    images  = galleryImages;
    current = index;
    update();
    lb.classList.add("open");
    document.body.style.overflow = "hidden";
  }

  function close() {
    lb.classList.remove("open");
    document.body.style.overflow = "";
  }

  function go(dir) {
    current = (current + dir + images.length) % images.length;
    update();
  }

  function update() {
    lbImg.src = images[current].full;
    lbImg.alt = images[current].alt;
    lbCounter.textContent = (current + 1) + " / " + images.length;
    var multi = images.length > 1;
    lbPrev.style.visibility = multi ? "" : "hidden";
    lbNext.style.visibility = multi ? "" : "hidden";
  }

  // ── Wire up each gallery section on the page ────────────────────────────────

  function initGallery(grid) {
    var items = grid.querySelectorAll("[data-gallery-item]");
    if (!items.length) return;

    // Collect image data from already-rendered DOM
    var galleryImages = Array.prototype.map.call(items, function (item) {
      var img = item.querySelector("img");
      return {
        full: img.getAttribute("data-full") || img.src,
        alt:  img.alt || "",
      };
    });

    items.forEach(function (item, index) {
      item.addEventListener("click", function () {
        open(index, galleryImages);
      });
      item.addEventListener("keydown", function (e) {
        if (e.key === "Enter" || e.key === " ") {
          e.preventDefault();
          open(index, galleryImages);
        }
      });
      item.setAttribute("tabindex", "0");
      item.setAttribute("role", "button");
      item.setAttribute("aria-label", "View image " + (index + 1));
    });
  }

  function init() {
    document.querySelectorAll(".gallery-grid").forEach(initGallery);
  }

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", init);
  } else {
    init();
  }

})();
